import { gql } from "@apollo/client";

export const PLAYLIST = gql`
  query Playlist($id: String!) {
    playlist(id: $id) {
      id
      clips {
        createdAt
        previewUrl
        score
        shareId
        playerGameIdentifier
        thumbnailOverlayUrl: thumbnailUrl(style: OVERLAY)
        thumbnailStandardUrl: thumbnailUrl(style: STANDARD)
        title
        user {
          _id
          avatarUrl
          username
        }
        username
        views
        tags {
          key
          value
        }
      }
    }
  }
`;
